(function (global) {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';
    var memory = global.CPStorefrontMemory;
    var grid = root.querySelector('[data-cp-recent-grid]');
    if (!memory || !grid) return;
    var current = {
      handle: root.dataset.handle,
      title: root.dataset.title,
      url: root.dataset.url,
      image: root.dataset.image || '',
      imageAlt: root.dataset.title,
      price: root.dataset.price || '',
      variant: Number(root.dataset.variant) || null,
      available: root.dataset.available === 'true'
    };
    var previous = memory.viewed().filter(function (item) {
      return item && item.handle && item.handle !== current.handle;
    }).slice(0, 4);

    previous.forEach(function (item) {
      var link = document.createElement('a');
      link.className = 'cp-recent__card';
      link.href = item.url;
      if (item.image) {
        var media = document.createElement('div');
        media.className = 'cp-recent__media';
        var image = document.createElement('img');
        image.loading = 'lazy';
        image.src = item.image;
        image.alt = item.imageAlt || item.title;
        media.appendChild(image);
        link.appendChild(media);
      }
      var title = document.createElement('strong');
      title.textContent = item.title;
      link.appendChild(title);
      var meta = document.createElement('span');
      meta.textContent = 'View again';
      link.appendChild(meta);
      grid.appendChild(link);
    });
    if (previous.length) root.hidden = false;
    memory.recordView(current);
  }

  function start() {
    document.querySelectorAll('[data-cp-recently-viewed]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-cp-recently-viewed]');
    if (root) init(root);
  });
})(window);
